import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CadastroRoutingModule } from './cadastro-routing.module';
import { TipoTarefaComponent } from './gerais/tipo-tarefa/tipo-tarefa.component';
import { TipoDocumentoComponent } from './gerais/tipo-documento/tipo-documento.component';
import { TipoAcaoComponent } from './gerais/tipo-acao/tipo-acao.component';
import { TipoDocumentoClienteComponent } from './gerais/tipo-documento-cliente/tipo-documento-cliente.component';
import {ComponentesModule} from "../../core/componentes/componentes.module";
import { IndexComponent } from './gerais/index/index.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgxPaginationModule} from "ngx-pagination";


@NgModule({
  declarations: [
    TipoTarefaComponent,
    TipoDocumentoComponent,
    TipoAcaoComponent,
    TipoDocumentoClienteComponent,
    IndexComponent
  ],
  imports: [
    CommonModule,
    CadastroRoutingModule,
    ComponentesModule,
    ReactiveFormsModule,
    FormsModule,
    NgxPaginationModule
  ]
})
export class CadastroModule { }
